import { IJournal, IJournalAction } from '../../../types/journal';
import { IGetRequest } from '../../../types/get_request';
import { options } from '../seo/seo';

export const QUESTIONS = 'questions/ACTION';
export const QUESTIONS_REQUEST = 'questions/ACTION_REQUEST';
export const QUESTIONS_SUCCESS = 'questions/ACTION_SUCCESS';
export const QUESTIONS_FAILURE = 'questions/ACTION_FAILURE';

export const initialState: IJournal = {
  items: [],
  pages_count: 0,
  count: 0,
};

const defaultAction: IJournalAction = {
  type: '',
  payload: {
    data: [],
    meta: {
      pagination: {
        page: 0,
        pages: 0,
        count: 0,
      },
    },
  },
};

export const profileQuestionsReducer = (state = initialState, action = defaultAction) => {
  switch (action.type) {
    case QUESTIONS_REQUEST:
      return state;

    case QUESTIONS_SUCCESS:
      return Object.assign({}, state, {
        items: action.payload.data,
        pages_count: action.payload.meta.pagination.pages,
        count: action.payload.meta.pagination.count,
      });

    case QUESTIONS_FAILURE:
      return Object.assign({}, state);

    default:
      return state;
  }
};

export const getProfileQuestions = (
    authorID: number,
  ): IGetRequest => {
  return {
    type: QUESTIONS,
    method: 'GET',
    payload: {
      pathname: '/v1/get-question-list',
      params: [{
        name: 'author_id',
        value: authorID,
      }],
    },
    request: true,
    ...options,
  };
};
